import * as React from "react";
import { FileUploadSection } from "../../generic/fileUploadSection";
import pdf_icon from "../../../../assets/images/pdf_icon.png";
export interface IKRADetails {
  kraDetails?: {};
  setKraDetails?: any;
  hidePhoto?: boolean;
}
export const KRADocumentUploadForm = (props: IKRADetails) => {
  const [kraDetails, setKraDetails] = React.useState<any>({
    webSign: {},
    panCard: {},
    photo: {},
  });
  const getFileType = (type?: any) => {
    let fileType: string = "";
    switch (type) {
      case "webSign":
        fileType = "Wetsign";
        break;
      case "panCard":
        fileType = "PAN";
        break;
      case "photo":
        fileType = "ProfilePhoto";
        break;
      default:
        break;
    }
    return fileType;
  };
  React.useEffect(() => {
    props.setKraDetails(kraDetails);
  }, [kraDetails]);
  const handleSubmitForDocument = (fileDetails: any, type?: any) => {
    let fileObj: any;
    if (fileDetails && fileDetails.docFile && fileDetails.base64Data) {
      let imgSrc = "";
      if (fileDetails.docFile.split(".")[1].toLowerCase() !== "pdf") {
        imgSrc = fileDetails.base64Data;
      }
      fileObj = {
        ["fileName"]: fileDetails.docFile,
        ["fileData"]: fileDetails.base64Data.split(",")[1],
        ["imgSrc"]: imgSrc,
        ["documentTypeName"]: getFileType(type),
      };
    }
    setKraDetails({
      ...kraDetails,
      [`${type}`]: fileObj ? fileObj : {},
    });
  };
  return (
    <>
      <div className="custom-row permantAddress--row">
        <p className="ei-text">Signature (Max size 1Mb)</p>
        <FileUploadSection
          disableCross={false}
          fileType={["pdf", "jpg", "jpeg", "tif", "tiff"]}
          onSubmit={(data: any) => {
            handleSubmitForDocument(data, "webSign");
          }}
          fileSize={1048576}//1MB size
          crop={true}
        />
        {!(
          kraDetails &&
          kraDetails["webSign"] &&
          kraDetails["webSign"].fileName &&
          kraDetails["webSign"].fileData
        ) && (
          <p className="text-indicator small--text-indicator noSpaceIndicator fileUploadIndicator">
            Please upload the photo of your signature on white paper with blue/black ink
          </p>
        )}
      </div>
      <div className="custom-row permantAddress--row pan-card-kra">
        <p className="ei-text">PAN card copy(Max size 1Mb)</p>
        <FileUploadSection
          disableCross={false}
          fileType={["pdf", "jpg", "jpeg", "tif", "tiff"]}
          onSubmit={(data: any) => {
            handleSubmitForDocument(data, "panCard");
          }}
          fileSize={1048576}//1MB size
        />
        {!(
          kraDetails &&
          kraDetails["panCard"] &&
          kraDetails["panCard"].fileName &&
          kraDetails["panCard"].fileData
        ) && (
          <p className="text-indicator small--text-indicator noSpaceIndicator fileUploadIndicator">
            Please upload the colour image of document directly taken from the original document
          </p>
        )}
      </div>
      {!props?.hidePhoto && (
        <div className="custom-row permantAddress--row pan-card-kra">
          <p className="ei-text">Photo(Max size 1Mb)</p>
          <FileUploadSection
            disableCross={false}
            fileSize={1048576}//1MB size
            fileType={["jpg", "jpeg"]}
            onSubmit={(data: any) => {
              handleSubmitForDocument(data, "photo");
            }}
          />
          {!(
            kraDetails &&
            kraDetails["photo"] &&
            kraDetails["photo"].fileName &&
            kraDetails["photo"].fileData
          ) && (
            <p className="text-indicator small--text-indicator noSpaceIndicator fileUploadIndicator">
              Please upload clear coloured photo
            </p>
          )}
        </div>
      )}
    </>
  );
};
export const ViewKRADocuments = (props: any) => {
  return (
    <>
      <label className="field-subHead bold-text field-subHead-corr-address">
        {props.title}
      </label>
      <span>
        <div
          className={
            !props.document.imgSrc
              ? "display-flex field-subHead"
              : "display-flex field-subHead"
          }
        >
          {props.document.imgSrc ? (
            <img
              src={props.document.imgSrc}
              height="50px"
              width="40px"
              className="ml05"
            />
          ) : (
            <img src={pdf_icon} height="50px" width="50px" />
          )}
          <p className={"bankcheckbox-left"}>{props.document.fileName}</p>
        </div>
      </span>
    </>
  );
};